import React, { useEffect } from 'react';
import './FloatingAchievement.css';

const FloatingAchievement = ({ combo, highestCps, onComplete, id }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) {
        onComplete(id);
      }
    }, 1500); // Match animation duration

    return () => clearTimeout(timer);
  }, [id, onComplete]);

  return (
    <div className="floating-achievement">
      <div className="combo-text">Combo x{combo}</div>
      <div className="cps-text">CPS {highestCps.toFixed(1)}/sec</div>
    </div>
  );
};

export default FloatingAchievement;